import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from './../../utils/styles'
import styles from './Stack.scss'

export default function Item({ children, fill }) {
  const className = classNames(styles.Item, fill && styles['Item-fill'])

  return <div className={className}>{children}</div>
}

Item.propTypes = {
  fill: PropTypes.bool,
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Stack/Item.js